import { useApolloClient } from "@apollo/client";
import { useCallback, useMemo } from "react";
import { GATHERING_QR_CODE } from "src/api/featureFlags";
import GetGatheringForQrCodeDocument from "src/api/graphql/__generated__/documents/GetGatheringForQrCodeDocument";
import GatheringPrivacy from "src/api/graphql/__generated__/enums/GatheringPrivacy";
import { useGatheringStore } from "src/contexts/GatheringContext";

const useGatheringQRCode = () => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const privacy = useGatheringStore((state) => state.privacy);
	const apolloClient = useApolloClient();

	const canShareQRCode = useMemo(() => {
		if (!privacy) return false;
		if (!GATHERING_QR_CODE) return false;
		if (privacy.includes(GatheringPrivacy.PasswordRequired)) return false;
		return true;
	}, [privacy]);

	const handleGetQRCode = useCallback(async () => {
		const { data } = await apolloClient.query({
			query: GetGatheringForQrCodeDocument,
			fetchPolicy: "network-only",
			variables: {
				input: {
					gatheringId,
				},
			},
		});
		if (
			data?.getGathering?.privacy &&
			data.getGathering.privacy.includes(GatheringPrivacy.PasswordRequired)
		) {
			return {};
		}

		return {
			qrCodeUrl: data?.getGathering?.shareQrCodeUrl,
		};
	}, [apolloClient, gatheringId]);

	return { handleGetQRCode, canShareQRCode };
};
export default useGatheringQRCode;
